import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Layout 和 Login 是首屏必需的，保持同步导入
import Layout from '@/components/Layout.vue'
import Login from '@/views/login/Login.vue'
const WechatBind = () => import( /* webpackChunkName: "wechat-bind" */ '@/views/wechat/WechatBind.vue')

// 其他页面使用懒加载实现代码分割
const Dashboard = () => import( /* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue')
const UserList = () => import( /* webpackChunkName: "system-user" */ '@/views/system/UserList.vue')
const RoleList = () => import( /* webpackChunkName: "system-role" */ '@/views/system/RoleList.vue')
const MenuList = () => import( /* webpackChunkName: "system-menu" */ '@/views/system/MenuList.vue')
const DeptList = () => import( /* webpackChunkName: "system-dept" */ '@/views/system/DeptList.vue')
const SystemConfig = () => import( /* webpackChunkName: "system-config" */ '@/views/system/SystemConfig.vue')
const LogList = () => import( /* webpackChunkName: "system-log" */ '@/views/system/LogList.vue')
const UserSupervisor = () => import( /* webpackChunkName: "system-supervisor" */ '@/views/system/UserSupervisor.vue')
const EmployeeList = () => import( /* webpackChunkName: "personnel" */ '@/views/personnel/EmployeeList.vue')
const ProcurementApply = () => import( /* webpackChunkName: "procurement-apply" */
	'@/views/procurement/ProcurementApply.vue')
const ProcurementList = () => import( /* webpackChunkName: "procurement-list" */
	'@/views/procurement/ProcurementList.vue')
const ProcurementRemittanceList = () => import( /* webpackChunkName: "procurement-remittance-list" */
	'@/views/procurement/ProcurementRemittanceList.vue')
const AssetList = () => import( /* webpackChunkName: "asset-list" */ '@/views/asset/AssetList.vue')
const AssetAdd = () => import( /* webpackChunkName: "asset-add" */ '@/views/asset/AssetAdd.vue')
const AssetApproval = () => import( /* webpackChunkName: "asset-approval" */ '@/views/asset/AssetApproval.vue')
const MailApply = () => import( /* webpackChunkName: "mail-apply" */ '@/views/mail/MailApply.vue')
const MailList = () => import( /* webpackChunkName: "mail-list" */ '@/views/mail/MailList.vue')
const NotificationList = () => import( /* webpackChunkName: "notification" */ '@/views/NotificationList.vue')
const ProjectList = () => import( /* webpackChunkName: "project-list" */ '@/views/project/ProjectList.vue')
const ProjectAdd = () => import( /* webpackChunkName: "project-add" */ '@/views/project/ProjectAdd.vue')
const PolicyList = () => import( /* webpackChunkName: "policy-list" */ '@/views/policy/PolicyList.vue')
const PolicyForm = () => import( /* webpackChunkName: "policy-form" */ '@/views/policy/PolicyForm.vue')
const WeeklyReportList = () => import( /* webpackChunkName: "report-weekly-list" */
	'@/views/report/WeeklyReportList.vue')
const WeeklyReportForm = () => import( /* webpackChunkName: "report-weekly-form" */
	'@/views/report/WeeklyReportForm.vue')
const MonthlyReportList = () => import( /* webpackChunkName: "report-monthly-list" */
	'@/views/report/MonthlyReportList.vue')
const MonthlyReportForm = () => import( /* webpackChunkName: "report-monthly-form" */
	'@/views/report/MonthlyReportForm.vue')
const ReimbursementList = () => import( /* webpackChunkName: "reimbursement-list" */
	'@/views/reimbursement/ReimbursementList.vue')
const ReimbursementApply = () => import( /* webpackChunkName: "reimbursement-apply" */
	'@/views/reimbursement/ReimbursementApply.vue')
const SealApplicationList = () => import( /* webpackChunkName: "seal-application-list" */
	'@/views/seal/SealApplicationList.vue')
const SealApplicationForm = () => import( /* webpackChunkName: "seal-application-form" */
	'@/views/seal/SealApplicationForm.vue')
const WebsiteMessageList = () => import( /* webpackChunkName: "website-message-list" */
	'@/views/website-message/WebsiteMessageList.vue')

const routes = [{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			title: '登录'
		}
	},
	{
		path: '/wechat/bind',
		name: 'WechatBind',
		component: WechatBind,
		hidden: true,
		meta: {
			title: '绑定OA账号'
		}
	},
	{
		path: '/',
		component: Layout,
		redirect: '/dashboard',
		children: [{
			path: 'dashboard',
			name: 'Dashboard',
			component: Dashboard,
			meta: {
				title: '首页',
				icon: 'el-icon-house'
			}
		}]
	},
	{
		path: '/system',
		component: Layout,
		redirect: '/system/user',
		meta: {
			title: '系统管理',
			icon: 'el-icon-setting'
		},
		children: [{
				path: 'user',
				name: 'UserList',
				component: UserList,
				meta: {
					title: '用户管理',
					icon: 'el-icon-user',
					permission: 'system:user:list'
				}
			},
			{
				path: 'role',
				name: 'RoleList',
				component: RoleList,
				meta: {
					title: '角色管理',
					icon: 'el-icon-s-custom',
					permission: 'system:role:list'
				}
			},
			{
				path: 'menu',
				name: 'MenuList',
				component: MenuList,
				meta: {
					title: '菜单管理',
					icon: 'el-icon-menu',
					permission: 'system:menu:list'
				}
			},
			{
				path: 'dept',
				name: 'DeptList',
				component: DeptList,
				meta: {
					title: '部门管理',
					icon: 'el-icon-office-building',
					permission: 'system:dept:list'
				}
			},
			{
				path: 'config',
				name: 'SystemConfig',
				component: SystemConfig,
				meta: {
					title: '系统配置',
					icon: 'el-icon-setting',
					permission: 'system:config:list'
				}
			}, {
				path: 'log',
				name: 'LogList',
				component: LogList,
				meta: {
					title: '操作日志',
					icon: 'el-icon-document',
					permission: 'system:log:list'
				}
			}, {
				path: 'supervisor',
				name: 'UserSupervisor',
				component: UserSupervisor,
				meta: {
					title: '人员管辖',
					icon: 'el-icon-connection',
					permission: 'system:supervisor:list'
				}
			}
		]
	},
	{
		path: '/personnel',
		component: Layout,
		redirect: '/personnel/list',
		meta: {
			title: '人员管理',
			icon: 'el-icon-user'
		},
		children: [{
			path: 'list',
			name: 'EmployeeList',
			component: EmployeeList,
			meta: {
				title: '人员列表',
				icon: 'el-icon-files',
				permission: 'personnel:list'
			}
		}]
	},
	{
		path: '/project',
		component: Layout,
		redirect: '/project/list',
		meta: {
			title: '项目管理',
			icon: 'el-icon-folder-opened'
		},
		children: [{
				path: 'list',
				name: 'ProjectList',
				component: ProjectList,
				meta: {
					title: '项目列表',
					icon: 'el-icon-document',
					permission: 'project:list'
				}
			},
			{
				path: 'approval',
				redirect: '/project/list',
				hidden: true
			},
			{
				path: 'add',
				name: 'ProjectAdd',
				component: ProjectAdd,
				meta: {
					title: '项目建档',
					icon: 'el-icon-edit',
					permission: 'project:apply'
				},
				hidden: true
			}
		]
	},
	{
		path: '/procurement',
		component: Layout,
		redirect: '/procurement/list',
		meta: {
			title: '采购管理',
			icon: 'el-icon-shopping-cart-2'
		},
		children: [{
				path: 'list',
				name: 'ProcurementList',
				component: ProcurementList,
				meta: {
					title: '采购列表',
					icon: 'el-icon-document',
					permission: 'procurement:list'
				}
			},
			{
				path: 'approval',
				name: 'ProcurementApproval',
				redirect: '/procurement/list',
				meta: {
					title: '采购审批',
					icon: 'el-icon-check',
					permission: 'procurement:list'
				},
				hidden: true
			},
			{
				path: 'remittance',
				name: 'ProcurementRemittanceList',
				component: ProcurementRemittanceList,
				meta: {
					title: '公对公汇款记录',
					icon: 'el-icon-bank-card',
					permission: 'procurement-remittance:list'
				}
			},
			{
				path: 'apply',
				name: 'ProcurementApply',
				component: ProcurementApply,
				meta: {
					title: '采购申请',
					icon: 'el-icon-edit',
					permission: 'procurement:apply'
				},
				hidden: true
			}
		]
	},
	{
		path: '/asset',
		component: Layout,
		redirect: '/asset/list',
		meta: {
			title: '资产管理',
			icon: 'el-icon-box'
		},
		children: [{
				path: 'list',
				name: 'AssetList',
				component: AssetList,
				meta: {
					title: '资产列表',
					icon: 'el-icon-collection',
					permission: 'asset:list'
				}
			},
			{
				path: 'approval',
				name: 'AssetApproval',
				component: AssetApproval,
				meta: {
					title: '资产审批',
					icon: 'el-icon-check',
					permission: 'asset:approval'
				},
				hidden: true
			},
			{
				path: 'add',
				name: 'AssetAdd',
				component: AssetAdd,
				meta: {
					title: '资产登记',
					icon: 'el-icon-plus',
					permission: 'asset:add'
				},
				hidden: true
			}
		]
	},
	{
		path: '/mail',
		component: Layout,
		redirect: '/mail/list',
		meta: {
			title: '邮寄管理',
			icon: 'el-icon-message'
		},
		children: [{
				path: 'list',
				name: 'MailList',
				component: MailList,
				meta: {
					title: '邮寄列表',
					icon: 'el-icon-tickets',
					permission: 'mail:list'
				}
			},
			{
				path: 'approval',
				redirect: '/mail/list',
				meta: {
					title: '邮寄审批',
					icon: 'el-icon-check',
					permission: 'mail:list'
				},
				hidden: true
			},
			{
				path: 'apply',
				name: 'MailApply',
				component: MailApply,
				meta: {
					title: '邮寄申请',
					icon: 'el-icon-edit',
					permission: 'mail:apply'
				},
				hidden: true
			}
		]
	},
	{
		path: '/report',
		component: Layout,
		redirect: '/report/weekly-list',
		meta: {
			title: '工作汇报',
			icon: 'el-icon-document'
		},
		children: [{
			path: 'weekly-list',
			name: 'WeeklyReportList',
			component: WeeklyReportList,
			meta: {
				title: '周报列表',
				icon: 'el-icon-date',
				permission: 'report:weekly:list'
			}
		}, {
			path: 'weekly-form',
			name: 'WeeklyReportForm',
			component: WeeklyReportForm,
			meta: {
				title: '周报填写',
				icon: 'el-icon-edit',
				permission: 'report:weekly:list'
			},
			hidden: true
		}, {
			path: 'monthly-list',
			name: 'MonthlyReportList',
			component: MonthlyReportList,
			meta: {
				title: '月报列表',
				icon: 'el-icon-date',
				permission: 'report:monthly:list'
			}
		}, {
			path: 'monthly-form',
			name: 'MonthlyReportForm',
			component: MonthlyReportForm,
			meta: {
				title: '月度考核',
				icon: 'el-icon-edit',
				permission: 'report:monthly:list'
			},
			hidden: true
		}]
	},
	{
		path: '/reimbursement',
		component: Layout,
		redirect: '/reimbursement/list',
		meta: {
			title: '报销管理',
			icon: 'el-icon-money'
		},
		children: [{
			path: 'list',
			name: 'ReimbursementList',
			component: ReimbursementList,
			meta: {
				title: '报销列表',
				icon: 'el-icon-tickets',
				permission: 'reimbursement:list'
			}
		}, {
			path: 'apply',
			name: 'ReimbursementApply',
			component: ReimbursementApply,
			meta: {
				title: '报销申请',
				permission: 'reimbursement:apply'
			},
			hidden: true
		}]
	},
	{
		path: '/seal',
		component: Layout,
		redirect: '/seal/list',
		meta: {
			title: '用章管理',
			icon: 'el-icon-document-checked'
		},
		children: [{
			path: 'list',
			name: 'SealApplicationList',
			component: SealApplicationList,
			meta: {
				title: '用章申请',
				icon: 'el-icon-document-checked',
				permission: 'seal:list'
			}
		}, {
			path: 'apply',
			name: 'SealApplicationForm',
			component: SealApplicationForm,
			meta: {
				title: '用章申请',
				permission: 'seal:apply'
			},
			hidden: true
		}]
	},
	{
		path: '/policy',
		component: Layout,
		redirect: '/policy/list',
		meta: {
			title: '制度管理',
			icon: 'el-icon-notebook-2'
		},
		children: [{
			path: 'list',
			name: 'PolicyList',
			component: PolicyList,
			meta: {
				title: '制度列表',
				icon: 'el-icon-notebook-2',
				permission: 'policy:list'
			}
		}, {
			path: 'form',
			name: 'PolicyForm',
			component: PolicyForm,
			meta: {
				title: '制度维护',
				permission: 'policy:add'
			},
			hidden: true
		}]
	},
	{
		path: '/website-message',
		component: Layout,
		redirect: '/website-message/list',
		meta: {
			title: '官网留言',
			icon: 'el-icon-chat-dot-square'
		},
		children: [{
			path: 'list',
			name: 'WebsiteMessageList',
			component: WebsiteMessageList,
			meta: {
				title: '留言列表',
				icon: 'el-icon-chat-line-square',
				permission: 'website-message:list'
			}
		}]
	},
	{
		path: '/notification',
		component: Layout,
		redirect: '/notification',
		meta: {
			title: '消息中心',
			icon: 'el-icon-bell'
		},
		children: [{
			path: '',
			name: 'NotificationList',
			component: NotificationList,
			meta: {
				title: '消息中心',
				icon: 'el-icon-bell'
			}
		}]
	},
	{
		path: '*',
		redirect: '/'
	}
]

const router = new VueRouter({
	mode: 'hash',
	routes
})

// 修复重复导航报错（点击首页 logo 等场景）
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		if (err.name !== 'NavigationDuplicated') throw err
	})
}

export default router
